<style>
/* #NewUserLayer .v--modal-box.v--modal {
  min-height: 480px !important;
  min-width: 500px !important;
} */
#NewUserLayer * {
  font-size: 12px;
}
#NewUserLayer .list--el--bold {
  font-weight: bold;
  color: rgba(0, 0, 0, 0.54);
}
/*#modals-container > div > div > div.v--modal-box.v--modal {
  height: 220px !important;
}*/

.bottom-text {
    vertical-align: bottom;
    display: table-cell;
    height: 40px;
}
</style>

<template>
  <Modal
    modalName="CopyPastFeatures"
    title="Wklejanie elementów warstwy"
    @opened="open"
    @closed="closed"
    @saved="save"
    :buttons="['save']"
  >
    <v-container>
      <v-layout row wrap>
        <p class="font--primary">Zamapuj pola do warstwy docelowej lub skopiuj tylko geometrię</p>
        
        <v-flex xs12>
          <v-checkbox label="Kopiuj tylko geometrię" v-model="onlyGeometry"></v-checkbox>
        </v-flex>
        <v-spacer/>
        <template v-if="!onlyGeometry">
          <v-flex xs12>
            <p class="font--primary">Lista pól do skopiowania, pasujących typów.</p>
          </v-flex>
          
          <template v-for="(to_field, index) in toFields" v-if="to_field.name != 'ogc_fid'">
            <v-flex xs3>
              <p class="bottom-text">{{to_field.display_name}}:</p>
            </v-flex>
            <v-flex xs3>
              <p class="bottom-text">"{{to_field.display_data_type}}"</p>
            </v-flex>
            <v-flex xs6>
              <v-select                    
                placeholder="dostępne pola"
                :items="fromFields[to_field.data_type]"
                item-text="display_name"
                :return-object="true"
                no-data-text="Brak pól do mapowania"
                v-model="selectedFields[to_field.name]"
              ></v-select>
            </v-flex>
          </template>
          
        </template>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import clone from "lodash/clone";
import each from "lodash/each";
import groupBy from "lodash/groupBy";
import mapValues from "lodash/mapValues";

mixin(_, {
  chain,
  map,
  clone,
  each,
  groupBy,
  mapValues,
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal
  },
  data: () => ({
    onlyGeometry : false,
    
    fromFields : [],
    toFields: [],
    selectedFields : {},
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },

  },
  methods: {
    show(title) {
      if (this.activeModals.indexOf(title) === -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    open() {

    },
    save() {
      this.send = true;
      
      const features = _.map(this.features, f => {
        const r = {
          type: "Feature",
          geometry : JSON.parse(JSON.stringify(f.geometry)),
          properties : {}
        };
        if (!this.onlyGeometry) {
          _.each(this.selectedFields, (field, key) => {
            if (field) {
              let value = f.properties[field.name];
              if ('dictionary' in field) {
                value = field.dictionary[`${value}`];
              }
              value = this.toValue(field.data_type, value);
              r.properties[key] = value;
            }
          });        
        }
        return r;
      });
      
      this.$root.$emit("saveCopyPastFeatures", features);
      this.$modal.hide("CopyPastFeatures");
    },
    closed() {
      if (!this.send) {
        this.$root.$emit("saveCopyPastFeatures", false);
      }
      
      this.fromFields = [];
      this.toFields = [];
      this.selectedFields = {};
      this.features = [];
      this.send = false;
      this.onlyGeometry = false;
    },
    
    mapDateType(type) {
      switch (type) {
        case 'string':
        case 'text':
          return 'text';
        case 'integer':
          return 'integer';
        case 'real':
        case 'float':
          return 'float';
        default:
          return 'text';
      }
    },
    mapDisplayDateType(type) {
      switch (type) {
        case 'string':
        case 'text':
          return 'Tekst';
        case 'integer':
          return 'Liczba całkowita';
        case 'real':
        case 'float':
          return 'Liczba rzeczywista';
        default:
          return 'Tekst';
      }
    },
    toValue(type, value) {
      if (value === null || value === undefined) {
        return value;
      }
      switch (type) {
        case 'text':
          return `${value}`;
        case 'integer':
        case 'float':
          return +value;
        default:
          return `${value}`;
      }
    },
    
    init(fromFields, toFields, features) {
      this.features = _.clone(features);
      this.send = false;
      
      this.toFields = _.map(toFields, (f) => {
        const fr = {
          display_name : f.display_name || f.name,
          name : f.name,
          data_type : f.data_type,
          display_data_type: this.mapDisplayDateType(f.data_type)
        };
        this.selectedFields[f.name] = false;
        return fr;
      });
      
      this.fromFields = _(fromFields).map((f) => {
        const fr = {
          display_name : f.display_name || f.name,
          name : f.name,
          data_type : this.mapDateType(f.data_type)
        };
        if ('dictionary' in f) {
          fr.dictionary = _.mapValues(f.dictionary, d => d.value);
        }
        return fr;
      }).groupBy('data_type').value();
      
      //console.log([_.clone(this.fromFields), _.clone(this.toFields)], [_.clone(fromFields), _.clone(toFields)], _.clone(features));
    }
  },
  created() {
    this.$root.$on("openCopyPastFeatures", this.init);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/modals/CopyPastFeatures.vue